'use client';

import { tsrShared } from '@/libs/ts-rest/ts-rest';
import { createOccupationChildrenQueryOptions } from '@/modules/shared/contracts';
import type { OccupationChildrenQueryOptions } from '@/modules/shared/contracts';

export const useOccupationChildrenQuery = (
	occupationId?: string,
	options?: Partial<OccupationChildrenQueryOptions>,
) => {
	const queryOptions = createOccupationChildrenQueryOptions(occupationId);

	return tsrShared.occupations.listChildrenById.useQuery({
		...queryOptions,
		...options,
	});
};
